import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import sweetalert from 'sweetalert2'
import {
  remove as removeDocumentSource
} from '../redux/documentSources'

export default function * requestRemoveDocumentSource (action) {
  const { id } = action.payload

  const optimisticAction = yield optimisticPut(removeDocumentSource({
    id
  }))

  try {
    yield call(apiAction, 'RemoveDocumentsSource', {
      id
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    if (error.code === 512) {
      try {
        const state = yield select()

        yield call(sweetalert, {
          text: state.kanbo.locale.messages['DOCUMENTS_SOURCE_REMOVE_IN_USE_ERROR'],
          type: 'error'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
